import { render, staticRenderFns } from "./floating-sidebar.vue?vue&type=template&id=b8ce9eda&scoped=true"
import script from "./floating-sidebar.vue?vue&type=script&lang=js"
export * from "./floating-sidebar.vue?vue&type=script&lang=js"
import style0 from "./floating-sidebar.vue?vue&type=style&index=0&id=b8ce9eda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ce9eda",
  null
  
)

export default component.exports